/**
 * Small seeded random generator. The same seed always yields the same
 * sequence, so anything generated with it renders identically on the
 * server and in the browser.
 */
export const createRandom = (seed: number): (() => number) => {
    let state = seed

    return () => {
        state = (state + 0x6d2b79f5) | 0

        let t = Math.imul(state ^ (state >>> 15), 1 | state)

        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t

        return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
}
